import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function PermissionGuard({ 
  component: Component, 
  requiredRoles = [], 
  fallbackPath = "/tickets" 
}) {
  const { currentUser } = useAuth();

  // Si no hay usuario logueado, redirigir a login
  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  // Si no se requieren roles específicos, permitir acceso
  if (requiredRoles.length === 0) {
    return <Component />;
  }

  // Verificar si el usuario tiene al menos uno de los roles requeridos
  const userRoles = Array.isArray(currentUser?.role) ? currentUser.role : [];
  
  // Comparación más flexible (sin espacios extra y sin case-sensitive)
  const normalizeRole = (role) => role?.trim().toLowerCase();
  const normalizedUserRoles = userRoles.map(normalizeRole);
  const normalizedRequiredRoles = requiredRoles.map(normalizeRole);
  
  const hasPermission = normalizedRequiredRoles.some(requiredRole => 
    normalizedUserRoles.some(userRole => userRole === requiredRole)
  );

  // DEBUG: Vamos a ver qué está pasando
  console.log('DEBUG PermissionGuard - User roles:', userRoles);
  console.log('DEBUG PermissionGuard - Normalized user roles:', normalizedUserRoles);
  console.log('DEBUG PermissionGuard - Required roles:', requiredRoles);
  console.log('DEBUG PermissionGuard - Normalized required roles:', normalizedRequiredRoles);
  console.log('DEBUG PermissionGuard - Has permission:', hasPermission);

  // Si no tiene permisos, redirigir a la página de fallback
  if (!hasPermission) {
    return <Navigate to={fallbackPath} replace />;
  }

  return <Component />;
}